




























































import {
  defineComponent,
  ref,
  Ref,
  computed,
  PropType
} from '@vue/composition-api'
import {
  TcButton,
  TcPageAlert
} from '@telia/shared-ui-components'
import AnslSpinner from '@/components/LoadingSpinner.vue'
import { ElementRef } from '@/types/common.types'
import { FileUploadEvent } from '@/types/contact-form-page.types'
import { MAX_ATTACHMENT_LIST_SIZE } from '@/constants/file-picker'

export default defineComponent({
  components: {
    TcButton,
    TcPageAlert,
    AnslSpinner
  },
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    maxFileSizeLimit: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    buttonLabel: {
      type: String,
      required: true
    },
    validationMessage: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    acceptableFileExtensions: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    alternativeButton: {
      type: Boolean,
      default: false
    },
    loadingIndexes: {
      type: Array as PropType<number[]>,
      default: () => []
    }
  },
  filters: {
    bytesToMegabytesFormat (bytes: number) {
      return bytes / 1024 / 1024
    }
  },
  setup: (props, context) => {
    const showMaximumFileSizeMessage: Ref<boolean> = ref(false)
    const fileInputRef: Ref<ElementRef> = ref({} as ElementRef)
    const uploadButtonRef: Ref<ElementRef> = ref({} as ElementRef)

    const handleUploadButtonClick = () => {
      showMaximumFileSizeMessage.value = false
      fileInputRef.value.click()
      // blur in order to upload button loose focus after click
      uploadButtonRef.value.$el.blur()
    }

    const isFileAlreadyAttached = (file: File) => {
      return (props.modelValue as File[]).some(f => f.name === file.name) //eslint-disable-line
    }

    const handleAttachmentUpload = (event: FileUploadEvent) => {
      const file = event.target.files[0]

      if (file) {
        if (props.maxFileSizeLimit < file.size) {
          showMaximumFileSizeMessage.value = true

        } else if (!isFileAlreadyAttached(file)) {
          fileInputRef.value.value = null

          context.emit('update:modelValue', [...props.modelValue, file])
          context.emit('blur')
        }
      }
    }

    const removeUploadedAttachment = (index: number) => {
      showMaximumFileSizeMessage.value = false
      context.emit('update:modelValue', props.modelValue.slice(0, index).concat(props.modelValue.slice(index + 1)))
    }

    const showUploadButton = computed(() => props.modelValue.length < MAX_ATTACHMENT_LIST_SIZE)

    return {
      handleUploadButtonClick,
      handleAttachmentUpload,
      removeUploadedAttachment,

      showMaximumFileSizeMessage,
      showUploadButton,
      fileInputRef,
      uploadButtonRef
    }
  }
})
